import { createActions } from 'redux-actions';

export const { toggleFilter } = createActions({
  TOGGLE_FILTER: name => name
});



// WEBPACK FOOTER //
// ./src/store/wishes/actions.js